export default __webpack_public_path__ + "static/media/aboutus32.5d8c20bf.webp";